import { Link } from "react-router-dom";
import { Github, Linkedin } from "lucide-react";
import "../styles/socialMedia.css";

const SocialLinks = () => {
	return (
		<div className="home_social_icons">
			<Link
				to="https://linkedin.com/in/junfelvelasco"
				target="_blank"
				rel="noopener noreferrer"
			>
				<Linkedin size={24} alt="Linkedin" aria-label="Linkedin"/>
			</Link>
			<Link
				to="https://github.com/vjunfel"
				target="_blank"
				rel="noopener noreferrer"
			>
				<Github size={24} alt="Github" aria-label="Github"/>
			</Link>
		</div>
	);
};

export default SocialLinks;
